import { DeadlineType, IScholarshipInfo, Presence } from '@studyportals/sp-scholarships-api-interface';
import { DeadlineFormField } from './deadline-editor/deadline-form-field';
import ScholarshipFormModel from './scholarship-form-model';
import { UTCDateTime } from '@studyportals/mb-platform-date-time';

export { toScholarshipInfo, toPresence };

const toScholarshipInfo = (source: ScholarshipFormModel): IScholarshipInfo => {
	const destinationCountries = source.destinationCountries.specific.keys.value ?? [];
	const destinationStates = source.destinationStates.specific.keys.value ?? [];
	const originCountries = source.originCountries.specific.keys.value ?? [];
	const originStates = source.originStates.specific.keys.value ?? [];
	const disciplines = source.disciplines.specific.keys.value ?? [];
	const degrees = source.degrees.value ?? [];
	const applicationBasis = source.applicationBasis.value ?? [];
	const formats = source.formats.value ?? [];
	const types = source.types.value ?? [];
	const providerOrganisationId = source.provider.providerOrganisationId.value ?? null;
	const providerBodyId = source.provider.providerBodyId.value ?? null;

	return {
		sourceUrl: source.sourceUrl.value ?? '',
		foundAtUrl: source.foundAtUrl.value ?? null,
		destinationCountries: [...destinationCountries],
		allDestinationCountries: source.destinationCountries.allSelected.value,
		destinationStates: [...destinationStates],
		allDestinationStates: source.destinationStates.allSelected.value,
		originCountries: [...originCountries],
		allOriginCountries: source.originCountries.allSelected.value,
		originStates: [...originStates],
		allOriginStates: source.originStates.allSelected.value,
		disciplines: [...disciplines],
		allDisciplines: source.disciplines.allSelected.value,
		grantDescription: source.grantDescription.value ?? '',
		grantAmount: source.grantAmount.value ?? null,
		grantCurrencyIso: source.grantCurrencyIso.valueOrNull,
		deadlineType: toDeadlineType(source.deadline),
		deadlineIso: source.deadline.date.value ? UTCDateTime.fromISOString(source.deadline.date.value).toJSON() : null,
		degrees: [...degrees],
		title: source.title.value ?? '',
		description: source.description.content.value ?? '',
		eligibility: source.eligibility.content.value ?? '',
		benefits: source.benefits.content.value ?? '',
		applicationInfo: source.applicationInfo.getNonWhitespaceContentOrNull(),
		applicationFormUrl: source.applicationFormUrl.value ?? null,
		providerOrganisationId,
		providerBodyId,
		minimumExperience: source.minimumExperience.valueOrNull,
		isAwardedMultipleTimes: source.isAwardedMultipleTimes.value ?? false,
		applicationBasis: [...applicationBasis],
		formats: [...formats],
		types: [...types],
		ageMin: source.ageMin.value ?? null,
		ageMax: source.ageMax.value ?? null,
		gender: source.gender.valueOrNull,
		race: source.race.valueOrNull === null ? [] : [source.race.valueOrNull],
		summary: source.summary.content.value ?? '',
	};
};

const toPresence = (source: ScholarshipFormModel): Presence => {
	return source.isPublished.value ? Presence.PUBLIC : Presence.PRIVATE;
};

const toDeadlineType = (source: DeadlineFormField): DeadlineType => {
	if (source.isAnytime.value) {
		return DeadlineType.ANY_TIME;
	}

	if (source.isNotSpecified.value) {
		return DeadlineType.NOT_SPECIFIED;
	}

	return DeadlineType.SPECIFIED;
};
